export const ALERT_EVENTS = {
  SHOW: 'show-alert',
  HIDE: 'hide-alert'
}

export const ALERT_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  SMALL_PRIMARY: 'smallPrimary',
  SMALL_SECONDARY: 'smallSecondary',
  SMALL_SUCCESS: 'smallSuccess',
  SMALL_ERROR: 'smallError',
  SMALL_WARNING: 'smallWarning',
  SMALL_INFO: 'smallInfo'
}

const DEFAULT_DURATION = 5000

const showAlert = ({type, heading, message, footer, duration}) => {
  const event = new CustomEvent(ALERT_EVENTS.SHOW, {
    detail: {message, type, duration, id: Date.now(), heading, footer}
  })

  window.dispatchEvent(event)
}

export const hideAlert = id => {
  const event = new CustomEvent(ALERT_EVENTS.HIDE, {
    detail: {id}
  })

  window.dispatchEvent(event)
}

export const alertService = {
  success: ({heading, message, footer, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SUCCESS,
      small: false,
      duration,
      footer,
      message,
      heading
    }),

  error: ({heading, message, footer, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.ERROR,
      small: false,
      duration,
      footer,
      message,
      heading
    }),

  warning: ({heading, message, footer, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.WARNING,
      small: false,
      duration,
      footer,
      message,
      heading
    }),

  info: ({heading, message, footer, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.INFO,
      small: false,
      duration,
      footer,
      message,
      heading
    }),

  smallPrimary: ({message, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SMALL_PRIMARY,
      small: true,
      duration,
      message
    }),

  smallSuccess: ({message, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SMALL_SUCCESS,
      small: true,
      duration,
      message
    }),

  smallSecondary: ({message, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SMALL_SECONDARY,
      small: true,
      duration,
      message
    }),

  smallError: ({message, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SMALL_ERROR,
      small: true,
      duration,
      message
    }),

  smallWarning: ({message, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SMALL_WARNING,
      small: true,
      duration,
      message
    }),

  smallInfo: ({message, duration = DEFAULT_DURATION}) =>
    showAlert({
      type: ALERT_TYPES.SMALL_INFO,
      small: true,
      duration,
      message
    })
}
